<template>
	<div class="list-group border-radius-2 no-border">
		<WidgetHeader :link="(this.list=='recent'?null:`/forms/list/${list}`)">{{ header }}</WidgetHeader>
		<FormsWidgetItem
		:item="item"
		v-for="item in items"
		:key="item.id"
		:list="list"
		@swipeLeftItem="swipeLeftItem"
		@swipeRightItem="swipeRightItem"
		@contextMenuItem="contextMenuItem"
		:swipedLeftItem="swipedLeftItem"
		@removeItem="removeItem"
		/>
		<div v-if="!items.length" class="list-group-item">
			{{ $t('nothing-here') }}
		</div>
	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";
import FormsWidgetItem from "../FormResponses/FormsWidgetItem";

export default {
	name: 'FormsWidget',
	props: ['list', 'limit', 'header'],
	components: {
		WidgetHeader,
		FormsWidgetItem,
	},
	data: function () {
		return {
			items: [],
			swipedLeftItem: null
		}
	},
	mounted() {
		if(this.list == 'recent'){
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/list`, {
				method: 'post',
				data: {
					limit: this.limit,
					userfrom_id: [
						this.$UserSession.getValue.call(this, 'id')
					]
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.items = json.formresponses;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});

		} else {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/list${this.list}`, {
				data: {
					limit: this.limit
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.items = json.formresponses;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		}
	},
	methods: {
		swipeLeftItem(item) {
			this.swipedLeftItem = item;
		},
		swipeRightItem(item) {
			if(this.swipedLeftItem && item.formresponse_id == this.swipedLeftItem.formresponse_id) {
				this.swipedLeftItem = null;
			}
		},
		contextMenuItem(item) {
			if(this.swipedLeftItem && item.formresponse_id == this.swipedLeftItem.formresponse_id) {
				this.swipedLeftItem = null;
			} else {
				this.swipedLeftItem = item;
			}
		},
		getItemIndex(item) {
			for (let i = 0; i < this.items.length; i++) {
				if (this.items[i].formresponse_id == item.formresponse_id) {
					return i;
				}
			}
		},
		removeItem(item) {
			const itemIndex = this.getItemIndex(item);
			this.items.splice(itemIndex, 1);
		}
	}
};
</script>
